import contract from './c1-contract.json';
import { STATUS_GRANT_LAYERS } from './creature-status-reader';

type Metadata = { integerWalkLayers: readonly string[]; presenceDefenseLayers: readonly string[] };
const retiredPayloadNames = ['partial_cover', 'full_cover', 'hunkered_down', 'flanked'];
const statusIds = Object.fromEntries(contract.vitality.statusCatalog.rows.map(row => [row.variable_name, row.item_id]));
/** Cover/flanking payload is retired in the cold writer; those markers own no layer shares. */
export function statusLayerPayloadRetired(id: string, ids: Readonly<Record<string, string>> = statusIds): boolean {
    return retiredPayloadNames.some(name => ids[name] === id);
}

/** The cold status writer's residual branch. Grants and derived clusters have their own writers. */
export function statusLayerIsResidual(layer: string, metadata: Metadata, inventoryInstance = false): boolean {
    return !STATUS_GRANT_LAYERS.includes(layer) && !['skill_roll_adv', 'skill_roll_dis', 'skill_roll_mod'].includes(layer)
        && layer !== 'teleport' && !layer.startsWith('speed_') && !metadata.integerWalkLayers.includes(layer)
        && (layer !== 'damage_mitigation' || inventoryInstance) && layer !== 'change_creature_size'
        && (inventoryInstance || !metadata.presenceDefenseLayers.includes(layer));
}

/** Same integer-walk selection as inventoryRuntimeMetadata, for held-member projections. */
export function statusIntegerWalkLayers(metadata: { dynamicLayers: readonly string[]; integerLayers: readonly string[];
    inventoryCapExcluded: readonly string[]; equippedHandledElsewhere: readonly string[] }): string[] {
    return metadata.dynamicLayers.filter(layer => layer !== 'teleport' && !layer.startsWith('speed_')
        && layer !== 'reach' && layer !== 'extra_attack' && metadata.integerLayers.includes(layer)
        && !metadata.inventoryCapExcluded.includes(layer) && !metadata.equippedHandledElsewhere.includes(layer));
}

const metadata: Metadata = { integerWalkLayers: statusIntegerWalkLayers({ ...contract.rollup, dynamicLayers: contract.grants.dynamicLayers }),
    presenceDefenseLayers: ['force_move_resistance', 'immune_to_forced_movement'] };
export const STATUS_RESIDUAL_LAYERS: readonly string[] = contract.grants.dynamicLayers.filter(layer => statusLayerIsResidual(layer, metadata));

/** These residuals are consumed at action time; updating their slots changes no derived cluster. */
export const STATUS_ACTION_RESIDUAL_LAYERS: ReadonlySet<string> = new Set(['spell_locked', 'no_healing_rolls']);
